import React from 'react';
import { Typography } from 'seagull';
import { Insight } from 'seagull/icons';
import styles from "./InsightCard.module.scss";
export function InsightCard(_ref) {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React.createElement(Insight, null), /*#__PURE__*/React.createElement(Typography, null, "What happens next")), /*#__PURE__*/React.createElement(Typography, {
    skin: "secondary"
  }, children));
}